import React from 'react'
import connect from "react-redux/es/connect/connect"
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'

import styles from 'common/components/style'

import DialogTitle from 'common/components/dialog/DialogTitle'
import DialogContent from 'common/components/dialog/DialogContent'
import DialogActions from 'common/components/dialog/DialogActions'

import { sendOptionalFunctions, optionalFunctionsChooserSetIsEnabled, hideOptionalFunctionsDialog, optionalFunctionsUpdate } from '../../../redux/admin/Actions'
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ToggleIconButton from "common/components/ToggleIconButton";


class OptionalFunctionsChooserDialogClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      controlsDisabled: false,
      tabIndex: 0,
    }
  }

  confirmThisStep(fn) {
    fn()
  }

  render() {
    if (!this.props.opened) return null
    const { classes, sendOptionalFunctions, hideOptionalFunctionsDialog, optionalFunctionsChooserSetIsEnabled } = this.props

    return (
      <Dialog
        onClose={hideOptionalFunctionsDialog}
        aria-labelledby="customized-dialog-title"
        open
      >
        <DialogTitle id="customized-dialog-title" onClose={hideOptionalFunctionsDialog}>
          Optional functions
        </DialogTitle>
        <DialogContent className={classes.dialogContentRoot}>
          <Typography>Choose optional functions</Typography>
          <List>
            {this.props.options.map((option) => {
              return <ListItem title={`id: ${option.name}`} key={option.name}><ToggleIconButton isOn={option.isEnabled} onClick={() => optionalFunctionsChooserSetIsEnabled({ name: option.name, isEnabled: !option.isEnabled })} />{option.displayName}</ListItem>
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={hideOptionalFunctionsDialog} color="secondary">
            Cancel
          </Button>
          <Button disabled={this.state.controlsDisabled} onClick={() => this.confirmThisStep(sendOptionalFunctions)} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export const AddYearEntityChooserDialog = connect(
  state => state.admin.optionalFunctionsChooser,
  {
    sendOptionalFunctions,
    hideOptionalFunctionsDialog,
    optionalFunctionsChooserSetIsEnabled,
    optionalFunctionsUpdate
  }
)(withStyles(styles, { withTheme: true })(OptionalFunctionsChooserDialogClass))

export default AddYearEntityChooserDialog
